import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=6110d5ce&scoped=true"
import script from "./ItemSelector.vue?vue&type=script&lang=js"
export * from "./ItemSelector.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=6110d5ce&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6110d5ce",
  null
  
)

export default component.exports